<template>
  <section-page
    title="Account"
    full-height
  >
    <app-loading-section :loading="false">
      <!--Stat Boxes-->
      <stats-section class="mt-200" heading="Current Month" has-columns>
        <stats-box
          label="Campaign Spend"
          class="column is-3"
          :request="getCampaignSpend"
        ></stats-box>

        <stats-box
          label="Campaign Units"
          class="column is-3"
          :request="getCampaignUnits"
        ></stats-box>

        <stats-box
          label="Qualified Leads Generated"
          class="column is-3"
          :request="getQualifiedLeadsGenerated"
        ></stats-box>

        <stats-box
          label="Cost per Qualified Lead"
          class="column is-3"
          :request="getCostPerQualifiedLead"
        ></stats-box>

        <stats-box
          label="Appointments"
          class="column is-3"
          :request="getAppointments"
        ></stats-box>

        <stats-box
          label="Offers"
          class="column is-3"
          :request="getOffers"
        ></stats-box>

        <stats-box
          label="Contracts"
          class="column is-3"
          :request="getContracts"
        ></stats-box>

        <stats-box
          label="Closed"
          class="column is-3"
          :request="getClosed"
        ></stats-box>

        <stats-box
          label="Deals"
          class="column is-3"
          :request="getDeals"
        ></stats-box>

        <stats-box
          label="Completed Deals"
          class="column is-3"
          :request="getCompletedDeals"
        ></stats-box>

        <stats-box
          label="Actual Profit"
          class="column is-3"
          :request="getActualProfit"
        ></stats-box>
      </stats-section>

      <!--Tables-->
      <stats-section class="mt-200" heading="Active Deals">
        <table-paginated
          :load-data="getActiveDealsData"
          :columns="activeDealsTableColumns"
          :per-page="15"
          is-narrow
          is-scrollable
          is-small-text
        ></table-paginated>
      </stats-section>

      <stats-section class="mt-200" heading="Completed Deals">
        <table-paginated
          :load-data="getCompletedDealsData"
          :columns="completedDealsTableColumns"
          :per-page="15"
          is-narrow
          is-scrollable
          is-small-text
        ></table-paginated>
      </stats-section>

      <stats-section class="my-200" heading="User Accountability">
        <stats-account-user-box
          v-for="userStat in accountabilityData"
          :key="userStat.id"
          :user-stat="userStat"
        />
      </stats-section>
    </app-loading-section>
  </section-page>
</template>

<script>
import dates from "../../services/dates";
import api from "../../api";
import StatsBox from "./components/StatsBox";
import {StatsTimeFrames} from "../../services/staticData";
import TablePaginated from "../../components/table/TablePaginated";
import StatsSection from "./components/StatsSection";
import {ENUMS} from "../../services/enums";
import {enumLabel} from "../../filters";
import Store from "../../store";
import router from "../../router";
import utils from "../../services/utils";
import StatsAccountUserBox from "./components/StatsAccountUserBox";

export default {
  components: {
    StatsAccountUserBox,
    StatsSection,
    TablePaginated,
    StatsBox
  },
  data() {
    return {
      isLoading: true,
      marketId: this.$store.getters.market.id,
      statsTimeFrame: StatsTimeFrames["month-to-date"],
      activeDealsTableColumns: [
        {
          label: 'Address',
          display(row, vue) {
            return `<span class="text-clickable">${row.property.line_1}</span>`;
          },
          onClick(row, vue) {
            vue.openRecordModal(row.id);
          },
        },
        {
          label: 'Status',
          display(row) {
            let status = Store.getters.statusesWithTrashed.find(status => status.id === row.status_id);
            return (status) ? status.label : '--';
          },
        },
        {
          label: 'Campaign',
          display(row) {
            let campaign = Store.getters.campaigns.find(campaign => campaign.id === row.campaign_id);
            return (campaign) ? campaign.label : '--';
          },
        },
        {
          label: 'Exit Strategy',
          display(row) {
            return enumLabel(row.exit_strategy, ENUMS.ExitStrategyEnum);
          },
        },
        {
          label: 'ARV',
          display(row) {
            return (row.buyingAnalysis) ? utils.formatCurrency(row.buyingAnalysis.after_repair_value, 0) : '--';
          },
        },
        {
          label: 'Purchase Price',
          display(row) {
            return (row.latest_offer) ? utils.formatCurrency(row.latest_offer.amount, 0) : '--';
          },
        },
        {
          label: 'Projected Profit',
          display(row) {
            return (row.projected_profit) ? utils.formatCurrency(row.projected_profit, 0) : '--';
          },

        },
        {
          label: 'Deal At',
          display(row) {
            return dates.formatAsDate(row.deal_at)
          },
        },
      ],
      completedDealsTableColumns: [
        {
          label: 'Address',
          display(row, vue) {
            return `<span class="text-clickable">${row.property.line_1}</span>`;
          },
          onClick(row, vue) {
            vue.openRecordModal(row.id);
          },
        },
        {
          label: 'Status',
          display(row) {
            let status = Store.getters.statusesWithTrashed.find(status => status.id === row.status_id);
            return (status) ? status.label : '--';
          },
        },
        {
          label: 'Campaign',
          display(row) {
            let campaign = Store.getters.campaigns.find(campaign => campaign.id === row.campaign_id);
            return (campaign) ? campaign.label : '--';
          },
        },
        {
          label: 'Exit Strategy',
          display(row) {
            return enumLabel(row.exit_strategy, ENUMS.ExitStrategyEnum);
          },
        },
        {
          label: 'ARV',
          display(row) {
            return (row.buyingAnalysis) ? utils.formatCurrency(row.buyingAnalysis.after_repair_value, 0) : '--';
          },
        },
        {
          label: 'Purchase Price',
          display(row) {
            return (row.latest_offer) ? utils.formatCurrency(row.latest_offer.amount, 0) : '--';
          },
        },
        {
          label: 'Sold Price',
          display(row) {
            return (row.selling_info && row.selling_info.sale_amount) ? utils.formatCurrency(row.selling_info.sale_amount, 0) : '--';
          },
        },
        {
          label: 'Projected Profit',
          display(row) {
            return (row.projected_profit) ? utils.formatCurrency(row.projected_profit, 0) : '--';
          },
        },
        {
          label: 'Actual Profit',
          display(row) {
            return (row.actual_profit) ? utils.formatCurrency(row.actual_profit, 0) : '--';
          },
        },
        {
          label: 'Deal At',
          display(row) {
            return dates.formatAsDate(row.deal_at)
          },
        },
        {
          label: 'Completed At',
          display(row) {
            return dates.formatAsDate(row.completed_at)
          },
        },
      ],
      accountabilityData: [],
    }
  },
  computed: {
    authUser() {
      return this.$store.getters.authUser;
    },
    canAccessFinancialStats() {
      if (this.authUser.is_owner) {
        return true;
      }

      return this.authUser.can_access_financial_stats;
    },
  },
  created() {
    this.getAccountabilityData()
  },
  methods: {
    openRecordModal(recordId) {
      router.replace({query: {lead: recordId}});
    },

    getCampaignSpend() {
      return api.stats.getCampaignSpendStatBox(this.marketId, this.statsTimeFrame);
    },
    getCampaignUnits() {
      return api.stats.getCampaignUnitsStatBox(this.marketId, this.statsTimeFrame);
    },
    getQualifiedLeadsGenerated() {
      return api.stats.getQualifiedLeadsGeneratedStatBox(this.marketId, this.statsTimeFrame);
    },
    getCostPerQualifiedLead() {
      return api.stats.getCostPerQualifiedLeadStatBox(this.marketId, this.statsTimeFrame);
    },


    getAppointments() {
      return api.stats.getAppointmentsStatBox(this.marketId, this.statsTimeFrame);
    },
    getOffers() {
      return api.stats.getBuyingOffersStatBox(this.marketId, this.statsTimeFrame);
    },
    getContracts() {
      return api.stats.getBuyingContractsStatBox(this.marketId, this.statsTimeFrame);
    },
    getClosed() {
      return api.stats.getBuyingClosingsStatBox(this.marketId, this.statsTimeFrame);
    },
    getDeals() {
      return api.stats.getDealsStatBox(this.marketId, this.statsTimeFrame);
    },
    getCompletedDeals() {
      return api.stats.getCompletedDealsStatBox(this.marketId, this.statsTimeFrame);
    },
    getActualProfit() {
      return api.stats.getActualProfitStatBox(this.marketId, this.statsTimeFrame);
    },


    getActiveDealsData(query = '') {
      return api.stats.getActiveDealsPaginatedData(this.marketId, this.statsTimeFrame, query);
    },
    getCompletedDealsData(query = '') {
      return api.stats.getCompletedDealsPaginatedData(this.marketId, this.statsTimeFrame, query);
    },
    getAccountabilityData() {
      return api.stats.getAccountabilityData(this.marketId, this.statsTimeFrame).then((response) => {
        this.accountabilityData = response.data
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

::v-deep {
  .not_date_column {
    background-color: $grey-50;
  }
}

.on-target {
  color: $green;
}

.off-target {
  color: $red;
}
</style>
